(() => {
  'use strict';
  const gold = '#c99c3b', ink = '#090909', white = '#f5f5f5', panel = '#151515', line = '#3c3c3c';
  const set = (el, prop, value) => el && el.style.setProperty(prop, value, 'important');
  const setMany = (el, entries) => entries.forEach(([p, v]) => set(el, p, v));
  const action = /write a review|ask a question|submit review|cancel review/i;

  function friendlyEmptyState(widget) {
    widget.querySelectorAll('*').forEach((el) => {
      if (el.children.length || el.dataset.bwFriendlyCopy) return;
      const copy = (el.textContent || '').trim();
      if (copy === 'Be the first to write a review') {
        el.textContent = 'No reviews yet — share your experience with Blade Wolf.';
        el.dataset.bwFriendlyCopy = 'true';
      }
      if (copy === 'No items found') {
        el.textContent = 'Your feedback helps fellow customers choose with confidence.';
        el.dataset.bwFriendlyCopy = 'true';
      }
    });
  }

  function polishWidget() {
    const widget = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-widget');
    if (!widget) return;
    setMany(widget, [['color', white], ['background-color', '#080808']]);
    friendlyEmptyState(widget);
    widget.querySelectorAll('button, a, [role="button"]').forEach((el) => {
      if (!action.test((el.textContent || '').trim())) return;
      setMany(el, [['background-color', gold], ['border-color', gold], ['border-radius', '0'], ['color', ink], ['font-weight', '800'], ['letter-spacing', '.08em'], ['text-transform', 'uppercase'], ['min-height', '44px']]);
      el.querySelectorAll('*').forEach((child) => set(child, 'color', ink));
    });
    widget.querySelectorAll('select, [class*="sort"], [class*="filter"]').forEach((el) => {
      setMany(el, [['background-color', panel], ['border-color', line], ['color', white], ['border-radius', '0']]);
    });
    widget.querySelectorAll('.jdgm-star, [class*="star"]').forEach((el) => {
      set(el, 'color', gold); set(el, 'fill', gold); set(el, 'stroke', gold);
    });
    widget.querySelectorAll('[class*="paginate"] a, [class*="paginate"] button, [class*="paginate"] span').forEach((el) => {
      setMany(el, [['background-color', panel], ['border-color', line], ['color', white], ['border-radius', '0']]);
    });
  }

  function polishModal() {
    document.querySelectorAll('.jdgm-write-rev-modal, .jdgm-write-review-modal, .jdgm-modal, [role="dialog"]').forEach((modal) => {
      setMany(modal, [['background-color', '#0d0d0d'], ['color', white], ['border-color', line]]);
      modal.querySelectorAll('button, a, [role="button"]').forEach((el) => {
        if (!action.test((el.textContent || '').trim())) return;
        setMany(el, [['background-color', gold], ['border-color', gold], ['color', ink], ['border-radius', '0']]);
      });
      modal.querySelectorAll('.jdgm-star, [class*="star"]').forEach((el) => { set(el, 'color', gold); set(el, 'fill', gold); set(el, 'stroke', gold); });
    });
  }

  function apply() { polishWidget(); polishModal(); }
  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('click', () => setTimeout(apply, 60), true);
  new MutationObserver(() => apply()).observe(document.documentElement, {childList: true, subtree: true});
  apply();
})();

